<template>
  <div class="apply-add-form">
    <template v-if="fromShow">
      <!-- <my-form
        ref="formRef"
        :data.sync="data"
        :loading="loading"
        :option="option"
        width="auto"
        :footer-visible="false"
        @submit="handleSubmit"
      /> -->
      <div class="dormitory-form">
        <div style="height: 800px">
          <validation-observer ref="simpleRules">
            <!-- <validation-observer ref="domitoryRules"> -->
            <b-form>
              <b-row class="form-add-body p-2">
                <b-col
                  v-for="(col, col_i) in columnsPersonal"
                  :key="col.field || col_i"
                  :md="col.span || 4"
                >
                  <b-form-group
                    :label-for="`v-add-${col.field}`"
                  >
                    <my-tooltip
                      :tooltip="col.SearchTooltip"
                      show-icon
                    >
                      <label :class="{'required':hasRequired(col.formOption)}">{{ col.label }}:</label>
                    </my-tooltip>
                    <validation-provider
                      #default="{ errors }"
                      :name="col.label"
                      :rules="col.formOption?col.formOption.rules:''"
                    >
                      <element-component
                        v-if="!col.hide"
                        :id="`v-add-${col.field}`"
                        v-model="form[col.field]"
                        :state="errors.length > 0 ? false:null"
                        :label="col.label"
                        :disabled="col.disabled"
                        :option="col"
                      />
                      <template v-if="col.disabled">
                        <small class="text-primary">{{ col.small }}</small>
                      </template>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>

          <div
            style="display: flex;justify-content: center;height: 340px;margin-bottom: 40px;"
          >
            <div style="height: 340px;">
              <a-transfer
                style="margin: 0 auto"
                :data-source="sourceTeams"
                show-search
                :titles="[this.$t('turnSite.sourceTeam'), this.$t('turnSite.targetTeam')]"
                :list-style="{
                  width: '260px',
                  height: '350px',
                  overflowY:'scroll'
                }"
                :target-keys="targetKeys"
                :selected-keys="selectedKeys"
                :render="item => item.label +' '+ item.code"
                :disabled="disabled"
                @change="handleChange"
                @selectChange="handleSelectChange"
                @scroll="handleScroll"
              />
            </div>
          </div>
        </div>

      </div>
      <!-- submit and reset -->
      <b-row>
        <b-col
          cols="12"
          class="my-form_btns"
        >
          <p class="text-secondary">
            {{ explain }}
          </p>
          <!-- class="mr-3" -->
          <b-button
            variant="primary"
            :disabled="loading"
            @click="handleSubmit"
          >
            {{ $t('_components.btns.send') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
    <component
      :is="flowKey"
      v-else
      :process-key="processKey"
      :explain="explain"
      @cancel="handleCustFormCancel"
      @close="$emit('close')"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BButton,
} from 'bootstrap-vue'
import MyForm from '@/components/myForm/index.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import applyAPI from '@/api/apply/index'
import templateFormAPI from '@/api/templateForm/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import website from '@/config/website';
import { templateFormat } from '@/util/func'
import { mapGetters } from 'vuex'
// custForm
// import Induction from './custForm/induction.vue'
import Induction from '@/views/apply/components/custForm/induction.vue'
import ElementComponent from '@/components/elementComponent.vue';
import MyTooltip from '@/components/myTooltip.vue';
// import WORKER from '@/api/worker/index';
import WORKER from '@/api/worker/workTeams'
import { getDetail } from '@/api/system/post';
import { processOption } from '@/config/processOption'
import { transferDormitory } from '@/api/worker/transferDormitory'

const transterDate = moment(new Date()).add(7, 'd').format('YYYY-MM-DD')
export default {
  name: 'ApplyAddForm',
  components: {
    MyForm,
    BRow,
    BCol,
    BButton,
    Induction,
    ElementComponent,
    MyTooltip,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    formId: {
      type: [Number, String],
      default: undefined,
    },
    processKey: {
      type: String,
      default: undefined,
    },
    explain: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      fromShow: true,
      flowKey: '',
      form: {

      },
      // form: {
      //   isPass: false,
      // },
      isDrafts: false,
      loading: false,
      treeLoading: false,
      data: {
        // deptId: null,
        // projectId: 6,
      },
      columns: [],
      sourceTeams: [],
      targetKeys: [],
      selectedKeys: [],
      hasDept: false,
      staffQueryParams: {
        8: {
          status: 1,
        },
        7: {
          status: 1,
        },
        1: {
          status: 1,
        },
      },
      baseData: [],
    }
  },
  computed: {
    ...mapGetters(['userAllInfo']),
    workerId() {
      return this.userAllInfo.workerId
    },
    companyId() {
      return this.userAllInfo.staffInfo.companyId || this.userAllInfo.workerInfo.companyId
    },
    option() {
      const columns = []
      const { deptId } = this.data
      this.columns.forEach(item => {
        const dictQuery = {}
        const temp = item
        if (item.dictCode === 'BLk' && item.field === 'newBlkId') {
          dictQuery.dormitoryId = this.data.newDormitoryId
          // temp.disabled = !this.data.newDormitoryId
          // temp.formOption.small = `${this.$t('_components.placeholder.firstInput')}Dormitory`
        }
        if (item.dictCode === 'UnitRoom' && item.field === 'newUnitId') {
          dictQuery.blkId = this.data.newBlkId
          // temp.disabled = !this.data.newBlkId
          // temp.formOption.small = `${this.$t('_components.placeholder.firstInput')}BLK`
        }
        temp.formOption.dictQuery = dictQuery
        columns.push(temp)
      })
      const option = {
        columns,
      }
      return option
    },
    columnsPersonal() {
      const columns = [
        {
          label: this.$t('turnSite.sourcePorject'),
          field: 'projectId',
          type: 'select',
          dictCode: 'project',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.$t('turnSite.sourceTeam'),
          field: 'teamId',
          type: 'select',
          dictQuery: {
            id: this.form.projectId,
          },
          dictCode: 'teams',
          disabled: !this.form.projectId,
          small: `${this.$t('_components.placeholder.firstSelect')}${this.$t('turnSite.sourcePorject')}`,
          formOption: {
            rules: 'required',
          },
        },
        {
          label: this.$t('turnSite.transitionDate'),
          field: 'transitionDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'MMM do yy',
          minDate: moment().format('YYYY-MM-DD'),
          formOption: {
            rules: 'required',
          },
        },
        {
          label: 'New Dormitory',
          field: 'newDormitoryId',
          type: 'select',
          dictCode: 'dormitory',
          formOption: {
            rules: 'required',
          },
        },
        {
          label: 'New BLK',
          field: 'newBlkId',
          type: 'select',
          dictCode: 'BLk',
          dictQuery: {
            dormitoryId: this.form.newDormitoryId,
          },
          formOption: {
          },
        },
        {
          label: 'New Unit',
          field: 'newUnitId',
          type: 'select',
          dictCode: 'UnitRoom',
          dictQuery: {
            blkId: this.form.newBlkId,
          },
          formOption: {
          },
        },
        {
          label: this.$t('turnSite.remark'),
          field: 'remark',
          span: 12,
          formOption: {
          },
        },
        {
          label: 'Attach',
          field: 'fileIds',
          type: 'upload',
          span: 12,
        },
      ]
      const columnss = columns.filter(el => el.field !== 'newTeamId')
      return columnss
    },
  },
  watch: {
    'form.teamId': {
      handler(val, oldVal) {
        // this.sourceTeams = []
        this.targetKeys = []
        this.selectedKeys = []
        if (this.form.projectId && val) {
          this.getTeamsTreeList()
        }
      },
    },
    'form.projectId': {
      handler(val, oldVal) {
        if (val) {
          this.targetKeys = []
          this.selectedKeys = []
        }
      },
    },
  },
  onLoad() {
  },
  mounted() {
    this.getDetailData()
  },
  methods: {
    // async onload(id, loading = true) {
    //   this.loading = loading
    //   const res = await WORKER.getWorkBaseDetail({ workerID: id })
    //   this.data = res.data.data
    //   this.loading = false
    // },
    async getDetailData() {
      // const { data } = await WORKER.getWorkBaseDetail({ workerID: this.workerId })
      // const baseData = data.data
      this.onLoad(this.formId)
    },
    handleChange(nextTargetKeys, direction, moveKeys) {
      this.targetKeys = nextTargetKeys;
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
    },
    handleScroll(direction, e) {
    },
    getTeamsTreeList() {
      this.treeLoading = true
      WORKER.getTeamsTreeList(1, -1, { id: this.form.teamId }).then(res => {
        this.treeLoading = false
        const workerList = res.data.data.records[0]
        const lists = workerList && workerList.children && workerList.children.length ? workerList.children : []
        const lists1 = lists.map(el => ({
          key: el.workerId,
          label: el.name,
          code: el.code,
        }))
        // this.sourceTeams = lists1.length && lists1.filter(el => el.key === this.currentId)
        this.sourceTeams = lists1.length ? lists1 : []
      })
    },
    // i18n
    i18n(param) {
      return this.$t(`_dormitory.${param}`)
    },
    hasRequired(option = {}) {
      const rules = option.rules || ''
      return rules.indexOf('required') !== -1
    },
    validationForm() {
      console.log(this.form, 'submit');
    },
    resetForm() {
      this.form = {}
    },
    onLoad(formId) {
      templateFormAPI.detail({ formId }).then(res => {
        const temp = res.data.data.records
        this.columns = templateFormat(temp)// , setDictQuery)
      })
    },
    send() {
      this.isDrafts = false
      this.$refs.formRef.validationForm()
    },
    arrayToStr(arr) {
      return arr.join(',')
    },
    handleSubmit() {
      const params = this.form
      // 查看fileIds字段是否有数据
      // console.log(this.form, 'form+++')
      // Object.entries(params).forEach(item => {
      //   params[item[0]] = Array.isArray(item[1]) ? item[1].join(',') : item[1]
      // })
      const ids = this.targetKeys.join(',')
      params.workerId = ids
      params.processKey = this.processKey
      params.formId = this.formId

      const option = processOption[this.formId]

      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const findUploads = this.columnsPersonal.filter(o => o.type === 'upload')
          findUploads.forEach(findUpload => {
            if (Array.isArray(params[findUpload.field])) {
              let key = findUpload.field
              if (findUpload.field === 'files') {
                key = 'fileIds'
              }
              params[key] = params[findUpload.field].map(o => o.attachId).join()
            }
            if (findUpload.field === 'files') {
              delete params[findUpload.field]
            }
          })

          transferDormitory(params, { option: JSON.stringify(option) }).then(res => {
            this.$emit('close')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('_default.toast.title'),
                icon: 'BellIcon',
                text: this.$t('_default.toast.text.success'),
                variant: 'success',
              },
            })
          })
        }
      })
    },
    handleCustFormCancel() {
      this.flowKey = ''
      this.fromShow = true
      this.onLoad(this.formId)
    },
  },
}

</script>

<style lang='scss' scoped>
@import '@/assets/scss/form/index.scss';

.form-add{
    &-nav{
        font-size: 20px;
        font-weight: 400;
        color: #13419D;
        line-height: 28px;
        overflow-x: hidden;
    }
    &-line{
        width: 100%;
        border-bottom: 1px solid #CAD6EB;
    }
    &-body{
        box-sizing: border-box;
    }
}
.apply-add-form{
    height: 100%;
    position: relative;
    box-sizing: border-box;
    // overflow-y: scroll;
    .dormitory-form {
      overflow-x: hidden;
      overflow-y: scroll;
      height: calc(100% - 75px);
    }
    .my-form{
      height: calc(100% - 100px);
      position: relative;
      overflow: hidden;
      &_btns{
        left: 0;
        right: 0;
        position: absolute;
        bottom: 0;
        text-align: center;
        border-top: 1px solid #EBE9F1;
        background: #FFF;
        padding: 1.5rem 0;
      }
    }
}
</style>
